/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeleteRepoRequest = {
  /**
   * The organization URL slug.
   */
  org: string;
  /**
   * The repository name (URL label).
   */
  name: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const DeleteRepoRequest$inboundSchema: z.ZodType<
  DeleteRepoRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  org: z.string(),
  name: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type DeleteRepoRequest$Outbound = {
  org: string;
  name: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const DeleteRepoRequest$outboundSchema: z.ZodType<
  DeleteRepoRequest$Outbound,
  z.ZodTypeDef,
  DeleteRepoRequest
> = z.object({
  org: z.string(),
  name: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function deleteRepoRequestToJSON(
  deleteRepoRequest: DeleteRepoRequest,
): string {
  return JSON.stringify(
    DeleteRepoRequest$outboundSchema.parse(deleteRepoRequest),
  );
}
export function deleteRepoRequestFromJSON(
  jsonString: string,
): SafeParseResult<DeleteRepoRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteRepoRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteRepoRequest' from JSON`,
  );
}
